import SystemDevelopmentOffers from "./SystemDevelopmentOffers";

const SystemDevelopment = () => {
  return (
    <section className="solution-item-page">
      <SystemDevelopmentOffers />
    </section>
  );
};

export default SystemDevelopment;
